import React from 'react';
import * as R from 'ramda';
import { bool, func, number, shape, string } from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { twoPartyLabelStyles, twoPartyPendingStyles } from '../SupplierAuthCard.styles';

const TwoPartyExchange = ({
  active,
  exchange,
  locationName,
  productAuthorizationId,
  productName,
  setDialogDetails,
  toggleTwoPartyExchange,
  supplierName,
}) => {
  const theme = useTheme();
  const exchangeConfirmed = exchange?.confirmed;
  const { viewBy } = useParams();

  const toggleTwoPartyExchangeParams = {
    actionName: 'toggleTwoPartyExchange',
    confirmAction: toggleTwoPartyExchange,
    header: `Turn ${exchangeConfirmed ? 'Off' : 'On'} Two Party Exchange?`,
    message: `Turn ${
      exchangeConfirmed ? 'off' : 'on'
    } Two Party Exchange for ${productName} loading for ${supplierName} at ${locationName}? Two Party Exchange can be turned ${
      exchangeConfirmed ? 'on' : 'off'
    } at any time.`,
    params: {
      exchangeConfirmed,
      locationName,
      productAuthorizationId,
      productName,
      supplierName,
      viewBy,
    },
  };

  const renderTwoPartyOptions = R.cond([
    [
      R.isNil,
      R.always(
        <Button
          disabled={!active}
          onClick={() => setDialogDetails(toggleTwoPartyExchangeParams)}
          variant="text"
        >
          Turn On
        </Button>
      ),
    ],
    [
      R.propEq('confirmed', true),
      R.always(
        <Button
          disabled={!active}
          onClick={() => setDialogDetails(toggleTwoPartyExchangeParams)}
          variant="text"
        >
          Turn Off
        </Button>
      ),
    ],
    [
      R.propEq('confirmed', false),
      R.always(
        <Typography sx={twoPartyPendingStyles(theme)}>Pending Supplier Acceptance</Typography>
      ),
    ],
  ]);

  return (
    <Box
      alignItems="center"
      bgcolor={exchangeConfirmed ? theme.palette.graphic.lighter : null}
      border={exchangeConfirmed ? null : `1px solid ${theme.palette.graphic.light}`}
      borderRadius="4px"
      display="flex"
      flexDirection="column"
      height={71}
      justifyContent="center"
      pt={1}
    >
      <Typography sx={twoPartyLabelStyles(theme)}>Two Party Exchange</Typography>
      {renderTwoPartyOptions(exchange)}
    </Box>
  );
};

export default TwoPartyExchange;

TwoPartyExchange.propTypes = {
  active: bool.isRequired,
  exchange: shape({
    confirmed: bool,
  }),
  locationName: string.isRequired,
  productAuthorizationId: number.isRequired,
  productName: string.isRequired,
  setDialogDetails: func.isRequired,
  supplierName: string.isRequired,
  toggleTwoPartyExchange: func.isRequired,
};

TwoPartyExchange.defaultProps = {
  exchange: null,
};
